var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('pb-icon',{staticClass:"fas fa-spinner fa-pulse fa-3x fa-fw"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }